import { styled } from '@mui/material';

export const StyledChunkScormWrap = styled('div')({});

export const StyledChunkScorm = styled('iframe')(({ theme }) => ({
	aspectRatio: '16/9',
	width: '100%',
	borderRadius: '8px',
	border: 0,

	[theme.breakpoints.down('xs')]: {
		borderRadius: '24px',
	},
}));
